import React from 'react'
import WarningCard from '../../pages/CreateRequestStepper.js/components/WarningCard'
import timeSinceLastUpdate from '../../utils/timeSinceLastUpdate'
import PropTypes from 'prop-types'

const MessageTimeSinceLastUpdate = ({ page, message }) => {
    const lastTimeUpdated = Number(localStorage.getItem('lastTimeUpdated'))
    const messageTimeSinceLastUpdate = timeSinceLastUpdate(lastTimeUpdated)

    const defaultMessage = `Your ${page} displays the latest information available as of`
    const messageWithTime = `${message ||
        defaultMessage} ${messageTimeSinceLastUpdate}.`

    return <WarningCard error={messageWithTime} warningSize={26} closeButton />
}

MessageTimeSinceLastUpdate.propTypes = {
    page: PropTypes.string,
    message: PropTypes.string,
}

export default MessageTimeSinceLastUpdate
